import { useState } from "react";
import {
	Dialog,
	DialogContent,
	DialogDescription,
	DialogHeader,
	DialogTitle,
} from "@/components/ui/dialog";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import { Label } from "@/components/ui/label";
import { Textarea } from "@/components/ui/textarea";
import { useApp } from "@/App";
import { Flame } from "lucide-react";

interface LoginDialogProps {
	open: boolean;
	onOpenChange: (open: boolean) => void;
}

export function LoginDialog({ open, onOpenChange }: LoginDialogProps) {
	const { login } = useApp();
	const [username, setUsername] = useState("");
	const [bio, setBio] = useState("");
	const [loading, setLoading] = useState(false);

	const handleSubmit = async (e: React.FormEvent) => {
		e.preventDefault();
		if (!username.trim()) return;
		setLoading(true);
		await login(username.trim(), bio.trim());
		setLoading(false);
		onOpenChange(false);
		setUsername("");
		setBio("");
	};

	return (
		<Dialog open={open} onOpenChange={onOpenChange}>
			<DialogContent className="sm:max-w-md">
				<DialogHeader>
					<DialogTitle className="flex items-center gap-2">
						<Flame className="h-5 w-5 text-orange-500" />
						Join the Roast
					</DialogTitle>
					<DialogDescription>
						Pick a username to start roasting landing pages and building your reputation.
					</DialogDescription>
				</DialogHeader>
				<form onSubmit={handleSubmit} className="space-y-4">
					<div className="space-y-2">
						<Label htmlFor="username">Username</Label>
						<Input
							id="username"
							placeholder="ConversionGuru"
							value={username}
							onChange={(e) => setUsername(e.target.value)}
							maxLength={20}
						/>
					</div>
					<div className="space-y-2">
						<Label htmlFor="bio">Bio (optional)</Label>
						<Textarea
							id="bio"
							placeholder="What's your expertise?"
							value={bio}
							onChange={(e) => setBio(e.target.value)}
							maxLength={160}
							rows={2}
						/>
					</div>
					<Button type="submit" className="w-full" disabled={!username.trim() || loading}>
						{loading ? "Joining..." : "Start Roasting"}
					</Button>
				</form>
			</DialogContent>
		</Dialog>
	);
}
